// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareOutlinedSvg
  }));
};

MinusSquareOutlined.displayName = 'MinusSquareOutlined';
export default React.forwardRef(MinusSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MinusSquareOutlined.js
// module id = 1497
// module chunks = 0